/* HFB-065 — 15% off countdown banner */
(function () {
  var STORAGE_KEY = 'hfb065-promo-end';
  var DURATION_MS = 30 * 60 * 1000;
  var timerStarted = false;

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function formatTime(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var minutes = Math.floor(total / 60);
    var seconds = total % 60;
    return pad(minutes) + ':' + pad(seconds);
  }

  function saveEndTime(end) {
    try {
      sessionStorage.setItem(STORAGE_KEY, String(end));
    } catch (e) {}
    return end;
  }

  function getEndTime() {
    try {
      var stored = sessionStorage.getItem(STORAGE_KEY);
      if (stored) {
        var parsed = parseInt(stored, 10);
        if (!isNaN(parsed) && parsed > Date.now()) return parsed;
      }
    } catch (e) {}
    return saveEndTime(Date.now() + DURATION_MS);
  }

  function renderTimers(end) {
    var remaining = formatTime(end - Date.now());
    document.querySelectorAll('[data-hfb-065-timer]').forEach(function (el) {
      el.textContent = remaining;
    });
  }

  function startTimer() {
    if (timerStarted) return;
    if (!document.querySelector('[data-hfb-065-timer]')) return;
    timerStarted = true;
    var end = getEndTime();
    renderTimers(end);
    setInterval(function () {
      if (end - Date.now() <= 0) {
        end = saveEndTime(Date.now() + DURATION_MS);
      }
      renderTimers(end);
    }, 1000);
  }

  function syncOffset() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;
    var height = Math.round(header.getBoundingClientRect().height || header.offsetHeight);
    if (!height) return;
    var root = document.documentElement;
    var next = height + 'px';
    if (root.style.getPropertyValue('--hfb-065-wrapper-pad').trim() === next) return;
    root.style.setProperty('--hfb-065-wrapper-pad', next);
    root.style.setProperty('--navDrawerOffset', next);
  }

  function init() {
    startTimer();
    syncOffset();
    requestAnimationFrame(function () {
      syncOffset();
      requestAnimationFrame(syncOffset);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', syncOffset);
  window.addEventListener('load', syncOffset);

  if (typeof ResizeObserver !== 'undefined') {
    var headerEl = document.getElementById('shopify-section-header');
    if (headerEl) {
      new ResizeObserver(syncOffset).observe(headerEl);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        var el = document.getElementById('shopify-section-header');
        if (el) new ResizeObserver(syncOffset).observe(el);
      });
    }
  }
})();
